import request from "../../utils/request";

export function doGetAllPartners(params) {
  return request("/partners", {
    method: "GET",
    params,
  });
}

export function doCreatePartner(params) {
  return request("/partners", {
    method: "POST",
    data: params,
  });
}

export function doUpdatePartner(params) {
  return request(`/partners/${params.id}`, {
    method: "PUT",
    data: params,
  });
}
